module.exports = __webpack_public_path__ + "img/ben-photo-night.3b4f5f41.jpg";